import {
	ExerciseDragAndDropContext,
	ExerciseDragAndDropContextProps,
} from "@ui/pages/program-builder/drag-drop/program-builder-drag-drop-context";
import { useComputedObservable } from "micro-observables";
import { useContext, useEffect, useState } from "react";

interface ExerciseDragAndDropHook {
	shouldAnimate: boolean;
	dragAndDropContext: ExerciseDragAndDropContextProps | null;
}

export const useExerciseDragAndDrop = (): ExerciseDragAndDropHook => {
	const dragAndDropContext = useContext(ExerciseDragAndDropContext);

	const dataIsLoading = useComputedObservable(
		() => dragAndDropContext?.programEditor.dataIsLoading.get(),
		[dragAndDropContext],
	);

	const [shouldAnimate, setShouldAnimate] = useState(!dragAndDropContext?.isDragging && !dataIsLoading);
	useEffect(() => {
		const handleDragEnd = () => {
			setShouldAnimate(!dataIsLoading);
		};

		const handleBeforeCapture = () => {
			setShouldAnimate(false);
		};
		dragAndDropContext?.onBeforeCapture.add(handleBeforeCapture);
		dragAndDropContext?.onDragEnd.add(handleDragEnd);
		handleDragEnd();
		return () => {
			dragAndDropContext?.onBeforeCapture.remove(handleBeforeCapture);
			dragAndDropContext?.onDragEnd.remove(handleDragEnd);
		};
	}, [dragAndDropContext?.onBeforeCapture, dragAndDropContext?.onDragEnd, dataIsLoading]);

	return { shouldAnimate, dragAndDropContext };
};
